import { LangEnum } from '@hylaa-npm/ipod';
import { request } from './index';
export const settingUrl = {
	getSetting: '/account/setting/get', // 验证码登录
	updateSet: '/account/setting/language/update',
};

export const getSetting = () => {
	return new Promise((res, rej) => {
		request(settingUrl.getSetting, {}, 'get')
			.then((request) => {
				res(request);
			})
			.catch((e) => {});
	});
};

export const updateSetting = (value: LangEnum) => {
	return new Promise((res, rej) => {
		request(settingUrl.updateSet, { body: value })
			.then((request) => {
				res(request);
			})
			.catch((e) => {});
	});
};
